<template>
    <page :showBackButton="true">
        <h1>Brauchst du Hilfe?</h1>
        <ion-card>
            <p><b>So können wir dir helfen:</b></p>
            <!-- <p>
                Die Funktion Co-Browsing bietet dir die Möglichkeit deine
                aktuelle Bildschirmansicht mit einem Wüstenrot Mitarbeiter zu
                teilen - und das in Echtzeit. Ziel ist, dir bei Fragen rund um
                die App schnellstmöglich weiter zu helfen.
            </p>
            <p>Vielleicht helfen dir auch diese Links weiter:</p> -->
            <ul>
                <li>
                    <a
                        href="#"
                        @click.prevent="
                            Browser.open({
                                url:
                                    'https://www.klickmal.at/app/die-wuestenrot-klickmal-app/tutorials.html',
                            })
                        "
                        >Alle Funktionen erklärt</a
                    >
                </li>
                <li>
                    Die häufigsten Fragen:
                    <ul>
                        <li>
                            <a
                                href="#"
                                @click.prevent="
                                    Browser.open({
                                        url:
                                            'https://www.klickmal.at/mobilitaet/kfz-versicherung/FAQ.html',
                                    })
                                "
                                >Mobilität</a
                            >
                        </li>
                        <li>
                            <a
                                href="#"
                                @click.prevent="
                                    Browser.open({
                                        url:
                                            'https://www.klickmal.at/zukunft/flexiblelife/faq.html',
                                    })
                                "
                                >Zukunft</a
                            >
                        </li>
                        <li>
                            <a
                                href="#"
                                @click.prevent="
                                    Browser.open({
                                        url:
                                            'https://www.klickmal.at/wohnen/immoflexkredit/faq.html',
                                    })
                                "
                                >Wohnen</a
                            >
                        </li>
                        <li>
                            <a
                                href="#"
                                @click.prevent="
                                    Browser.open({
                                        url:
                                            'https://www.klickmal.at/mein-geld/bausparen/faq.html',
                                    })
                                "
                                >Mein Geld</a
                            >
                        </li>
                    </ul>
                </li>
            </ul>
        </ion-card>

        <!-- <div id="CV" class="ion-margin-top">
            <ion-button
                expand="block"
                type="button"
                id="CV_START"
                onclick="CV.cobrowse.start()"
                style="display: block;"
                >Co-Browsing starten</ion-button
            >
            <ion-button
                expand="block"
                type="button"
                id="CV_STOP"
                onclick="CV.cobrowse.stop()"
                style="display: none;"
                >Co-Browsing beenden</ion-button
            >
        </div> -->
        <!-- <div id="LV" class="ion-margin-top">
            <h1>LiveView</h1>
            <ion-button
                expand="block"
                type="button"
                id="LV_START"
                onclick="LV.liveview.startSharing()"
                style="display:block;"
                >Start LiveView</ion-button
            >
            <ion-button
                expand="block"
                type="button"
                id="LV_STOP"
                onclick="LV.liveview.stopSharing()"
                style="display:none;"
                >Stop LiveView</ion-button
            >
        </div> -->
    </page>
</template>

<script>
import Page from "@/components/Page";
import { Plugins } from "@capacitor/core";

// function initFunction() {
//     var btnStop = document.getElementById("CV_STOP");
//     var btnStart = document.getElementById("CV_START");
//     CV.cobrowse.addCobrowsingStartedListener(function () {
//         btnStop.style.display = "block";
//         btnStart.style.display = "none";
//     });
//     CV.cobrowse.addCobrowsingStoppedListener(function () {
//         btnStop.style.display = "none";
//         btnStart.style.display = "block";
//     });
// }

// function initLVFunction() {
//     var btnStop = document.getElementById("CV_STOP");
//     var btnStart = document.getElementById("CV_START");
//     CV.liveview.addSessionStartedListener(function() {
//         btnStop.style.display = "block";
//         btnStart.style.display = "none";
//     });
//     CV.liveview.addSessionStoppedListener(function() {
//         btnStop.style.display = "none";
//         btnStart.style.display = "block";
//     });
// }

export default {
    components: { Page },
    data() {
        return {
            Browser: Plugins.Browser,
        };
    },
    // mounted() {
    //     if (!window.CVLoaded) {
    //         window.CVLoaded = initFunction;
    //     } else {
    //         initFunction();
    //     }
    // },
    methods: {},
};
</script>
